export function handleURLParams(campaigns = []) {
    if (!window) {
        return;
    }

    const campaignId = new URLSearchParams(window.location.search).get(
        "campaign"
    );
    const campaign = campaigns.find(({ id }) => id === campaignId) ?? null;

    if (campaign) {
        sessionStorage.setItem("awCampaign", btoa(JSON.stringify(campaign)));
    }

    /**
     * PNR and DNR are custom params (newsletter related) from Infratec that
     * should be stored and passed to the forms when present in the session.
     */
    const pnr = new URLSearchParams(window.location.search).get("pnr");

    if (pnr) {
        sessionStorage.setItem("pnr", pnr);
    }

    const dnr = new URLSearchParams(window.location.search).get("dnr");

    if (dnr) {
        sessionStorage.setItem("dnr", dnr);
    }
}
